import { definePlatformSetting } from '@crest/platform-contracts/settings';
import { z } from 'zod';
export const mitigationDryingReportDataConfigurationValueSchema = z.strictObject({
    maximumReadings: z.number().int().min(100).max(20_000),
    maximumDailySessions: z.number().int().min(30).max(5_000),
    maximumTreatments: z.number().int().min(10).max(10_000),
    maximumMoldClearances: z.number().int().min(10).max(10_000),
});
export const mitigationDryingReportDataConfigurationSetting = definePlatformSetting({
    definition: {
        key: 'mitigation.drying-report-data.configuration',
        moduleId: 'mitigation',
        title: 'Mitigation drying report-data limits',
        helpText: 'Bounds the Mitigation-owned fact projection supplied to a separately installed Documents renderer.',
        configurationDomain: 'module',
        valueType: 'object',
        schemaVersion: 1,
        codedFallback: {
            maximumReadings: 5_000,
            maximumDailySessions: 1_000,
            maximumTreatments: 5_000,
            maximumMoldClearances: 5_000,
        },
        permittedScopes: ['platform', 'plan', 'tenant'],
        mergeStrategy: 'replace',
        clientSafe: false,
        serverOnly: true,
        sensitive: false,
        tenantEditable: true,
        userOverridable: false,
        offlineEligible: false,
        safetyClass: 'protected',
    },
    valueSchema: mitigationDryingReportDataConfigurationValueSchema,
});
export const mitigationDryingReportDataSettingRegistrations = [
    mitigationDryingReportDataConfigurationSetting,
];
//# sourceMappingURL=mitigation-drying-report-data-setting-definitions.js.map